







































































































import { EmailBulkDistrItemImpl, FileItem } from "@/store/user_management/distr_moderation/types";
import { Vue, Component } from "vue-property-decorator";
import { Action } from "vuex-class";
import { downloadBase64ToFile } from "@/utils/download-helper"
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";
import {InputWings} from "wings-ui-components";

@Component({components:{InputWings}})
export default class EmailDistribution extends Vue {
  @Action("getBulkDistrItem") actionGetDistributionItem: any;
  @Action("actionLog") actionLog: any;

  private distribution = new EmailBulkDistrItemImpl();
  private logObject: ActionLog = {};

  private editorConfig: object = {
    allowedContent: true,
    fullPage: true,
    language: this.$i18n.locale,
  }
  private editorUrl = `${process.env.BASE_URL}ckeditor/ckeditor.js`

  async created() {
    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Distribution",
          addititional_info: getTranslatedParams({channel: this.$route.params.channel, id: this.$route.params.id})
        }
        await this.actionGetDistributionItem(this.$route.params.id).then((data: EmailBulkDistrItemImpl) => {
          this.distribution = Object.assign({}, this.distribution, data);
        });
        await this.actionLog(this.logObject);
      } catch (err){
        await this.actionLog({...this.logObject, action_status: "failed"});
      }
    }
  }

  isCheckToEmpty(file: FileItem): boolean{
    return file && Object.keys(file).length !== 0;
  }

  downloadFile(file: FileItem): void{
    downloadBase64ToFile(file);
  }
}
